/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnrollmentDto } from '../../models/enrollment-dto';
import { UpdateEnrollmentDto } from '../../models/update-enrollment-dto';

export interface EnrollmentControllerUpdate$Params {
  id: string;
      body: UpdateEnrollmentDto
}

export function enrollmentControllerUpdate(http: HttpClient, rootUrl: string, params: EnrollmentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrollmentDto>> {
  const rb = new RequestBuilder(rootUrl, enrollmentControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnrollmentDto>;
    })
  );
}

enrollmentControllerUpdate.PATH = '/api/enrollment/{id}';
